/* eslint-disable @typescript-eslint/no-redeclare */
import { Static, Type } from '@sinclair/typebox';

export type JobScheduleType = Static<typeof JobScheduleType>;
export const JobScheduleType = Type.Union(
  [Type.Literal('at'), Type.Literal('cron'), Type.Literal('rate')],
  { default: 'cron' },
);
